import React, { FC } from 'react';
import ReactMarkdown from 'react-markdown';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useSelector } from 'store';
import { ArrowLeftIcon } from 'components/SvgIcons';
import Button from 'components/Button/Button';

import KliparoSectionsList from './KliparoSectionsList/KliparoSectionsList';

import './KliparoProjectOverview.scss';
import CreateTicketButton from '../../../../components/CreateTicketButton/CreateTicketButton';

export interface KliparoProjectOverviewProps {}

const KliparoProjectOverview: FC<KliparoProjectOverviewProps> = () => {
  const { t } = useTranslation();
  const name = useSelector((store) => store.rfp.data.name);
  const description = useSelector((store) => store.rfp.data.rfp_description);

  return (
    <div className="enkrateia-kliparo-project-overview">
      <div className="head">
        <div className="title">
          <Link to="/dashboard" className="back-to-dashboard">
            <ArrowLeftIcon size={14} color="#2C2B63" />
            {t('pages.projectOverview.mainPanel.goBackToDashboard')}
          </Link>
          <div className="head-content">
            <div className="description">
              <h1>{name}</h1>
              <ReactMarkdown linkTarget="_blank" className="context-0">
                {description}
              </ReactMarkdown>
            </div>
            <div className="actions">
              <CreateTicketButton rfpRelated />
              <Button variant="primary" disabled>
                {t('pages.projectOverview.mainPanel.startSubmissionProcess')}
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="body">
        <KliparoSectionsList />
      </div>
    </div>
  );
};

export default KliparoProjectOverview;
